'use client';
import PageTransitionWrapper from './PageTransitionWrapper';
import { RenderBuilderContent } from '../utils/RenderBuilderContent';

export default function BuilderContentWithTransition(props) {
  return (
    <PageTransitionWrapper>
      <RenderBuilderContent {...props} />
    </PageTransitionWrapper>
  );
}
